import React from "react";
import BpoCards from "./Bpo/BpoCards";
import Card from "../../components/page/Card";
import BpoDataTable from "./Bpo/BpoDataTable";
import NovoBpoModal from "./Bpo/NovoBpoModal";
import useApi from "../../hooks/useApi";
import LocalidadeApiClient from "../../api/localidade";
import ErrorSwal from "../../components/Swal/errorSwal";
import Validation from "../../helpers/Validation";
import CommonSwal from "../../components/Swal/commonSwal";
import OptionsSwal from "../../components/Swal/optionsSwal";
import ProcessoBpoModal from "./Bpo/ProcessoBpoModal";
import TimelineApiClient from "../../api/timeline";
import CnaeApiClient from "../../api/cnae";
import Format from "../../helpers/Format";

function Bpo() {
  const [values, setValues] = React.useState({});
  const [cards, setCards] = React.useState({});
  const [processos, setProcessos] = React.useState([]);
  const [servicos, setServicos] = React.useState([]);
  const [novoBpoModal, setNovoBpoModal] = React.useState(false);
  const [processoBpoModal, setProcessoBpoModal] = React.useState(false);

  const { request: getCep, data: cepResponse } = useApi(
    LocalidadeApiClient.buscaCep
  );
  const { request: getProcessos, data: processosResponse } = useApi(
    TimelineApiClient.getProcessosBpo
  );
  const { request: getServicos, data: servicosResponse } = useApi(
    CnaeApiClient.listItensServico
  );
  const novoProcessoBpoApi = useApi(TimelineApiClient.novoProcessoBpo);
  const getProcessoApi = useApi(TimelineApiClient.getProcessoBpo);
  const salvaProcessoApi = useApi(TimelineApiClient.salvaProcessoBpo);
  const deletarProcessoApi = useApi(TimelineApiClient.deletarProcessoBpo);
  const finalizarProcessoApi = useApi(TimelineApiClient.finalizarProcessoBpo);

  //Busca processos ao renderizar tela
  React.useEffect(() => {
    getProcessos();
  }, [getProcessos]);

  //Define o retorno da api no valor do estado
  React.useEffect(() => {
    if (processosResponse) {
      const transformedProcessos = processosResponse.map((linha) => ({
        ...linha,
        dados_empresa: JSON.parse(linha.dados_empresa),
      }));
      const valor_total = transformedProcessos.reduce(
        (accumulator, processo) =>
          accumulator + (processo.status === "CONCLUIDA" ? 1 : 0),
        0
      );
      const ticket_medio = transformedProcessos.reduce(
        (accumulator, processo) =>
          accumulator + (processo.status === "CONCLUIDA" ? 0 : 1),
        0
      );
      const processos = transformedProcessos.length;

      setCards({
        valor_total,
        processos,
        ticket_medio,
      });
      setProcessos(transformedProcessos);
    }
  }, [processosResponse]);

  //Busca serviços ao renderizar tela
  React.useEffect(() => {
    getServicos();
  }, [getServicos]);

  //Define o retorno da api no valor do estado
  React.useEffect(() => {
    if (servicosResponse) setServicos(servicosResponse);
  }, [servicosResponse]);

  const togNovoBpoModal = () => {
    setValues({});
    setNovoBpoModal(true);
  };

  const criarNovoProcesso = async () => {
    const formData = new FormData();
    formData.append("nome", values?.nome);
    formData.append("cnpj", Format.formatCNPJCPF(values?.cnpj));
    formData.append("data_assinatura", values?.data_assinatura);
    formData.append("cep", values?.cep);
    formData.append("codigo_cidade", values?.codigo_cidade);
    formData.append("logradouro", values?.logradouro);
    formData.append("numero", values?.numero);
    formData.append("bairro", values?.bairro);
    formData.append("cidade", values?.cidade);
    formData.append("uf", values?.uf);

    if (values?.cep && !values?.codigo_cidade)
      return ErrorSwal({
        text: "Favor inserir um CEP válido.",
      });

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    if (Validation.validaCnpj(values?.cnpj))
      return ErrorSwal({
        text: "Favor inserir um CNPJ válido.",
      });

    formData.append("complemento", values?.complemento || "");

    const response = await novoProcessoBpoApi.request(formData);
    if (!response) return;
    CommonSwal({ title: "Novo processo criado com sucesso!", icon: "success" });
    setNovoBpoModal(false);
    getProcessos();
  };

  const togProcessoBpoModal = async (uid) => {
    const response = await getProcessoApi.request(uid);
    const dados = response?.dados_empresa;
    const { bpo_config = {}, endereco_empresa = {} } = dados;

    setValues({
      ...response,
      ...dados,
      ...bpo_config,
      ...endereco_empresa,
      codigo_cidade: endereco_empresa?.cod_cidade,
      empresa_id: uid,
      color_hex: bpo_config?.color_hex ? bpo_config.color_hex : "#FC6408",
    });
    setProcessoBpoModal(true);
  };

  const deletarProcesso = (uid) => {
    OptionsSwal({
      icon: "question",
      title: "Você realmente deseja excluir esse processo?",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await deletarProcessoApi.request(uid);

        if (!response) return;
        CommonSwal({
          title: "Processo de abertura deletado",
          icon: "success",
        });
        getProcessos();
      }
    });
  };

  const finalizarProcesso = async (processo, uid) => {
    try {
      const formData = new FormData();

      let empresa = processo?.razao_social.replace(/[^a-zA-Z0-9 ]/g, "");
      empresa = empresa.replace(" ", "_");

      formData.append("empresa", empresa);
      formData.append("cnpj_empresa", Format.formatCNPJCPF(processo?.cnpj));
      formData.append("nome_empresa", processo?.razao_social);
      formData.append("contabilidade", "Orangiuz");
      formData.append("cnpj", Format.formatCNPJCPF(processo?.cnpj));

      if (Validation.verificarForm(formData))
        return ErrorSwal({
          text: "Favor preencher todos os dados obrigatórios.",
        });

      const response = await finalizarProcessoApi.request(uid, formData);
      if (!response) return;
      CommonSwal({
        title: "Processo finalizado com sucesso!",
        icon: "success",
      });
      getProcessos();
    } catch (e) {
      console.warn(e);
    }
  };

  const salvarProcesso = async () => {
    const formData = new FormData();
    formData.append("razao_social", values?.razao_social);
    formData.append("cnpj", Format.formatCNPJCPF(values?.cnpj));
    formData.append("alias_email", values?.alias_email);
    formData.append("complemento_titulo", values?.complemento_titulo);
    formData.append("height_logo", values?.height_logo);
    formData.append("width_logo", values?.width_logo);
    formData.append("color_hex", values?.color_hex);
    formData.append("cep", values?.cep);
    formData.append("logradouro", values?.logradouro);
    formData.append("numero", values?.numero);
    formData.append("bairro", values?.bairro);
    formData.append("cidade", values?.cidade);
    formData.append("uf", values?.uf);
    formData.append("itemListaServicoLC116", values?.itemListaServicoLC116);
    formData.append("descricaoItem", values?.descricaoItemServico);
    formData.append("aliquotaIss", values?.aliquotaIss);
    formData.append("codigo_cidade", values?.codigo_cidade);

    if (values?.cep && !values?.codigo_cidade)
      return ErrorSwal({
        text: "Favor inserir um CEP válido.",
      });

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    formData.append(
      "codigoServicoMunicipio",
      values?.codigoServicoMunicipio || ""
    );
    formData.append("compl", values?.compl || "");
    formData.append("logo_empresa", values?.logo_empresa || "");

    const response = await salvaProcessoApi.request(
      values?.empresa_id,
      formData
    );
    if (!response) return;
    CommonSwal({ title: "Dados salvos com sucesso!", icon: "success" });
    setProcessoBpoModal(false);
    getProcessos();
  };

  return (
    <>
      <div className="row">
        <BpoCards cards={cards} />
      </div>
      <Card>
        <BpoDataTable
          linhas={processos}
          togNovoBpoModal={togNovoBpoModal}
          togProcessoBpoModal={togProcessoBpoModal}
          deletarProcesso={deletarProcesso}
          finalizarProcesso={finalizarProcesso}
        />
      </Card>
      <NovoBpoModal
        cepApi={{ getCep, cepResponse }}
        modalHook={{ novoBpoModal, setNovoBpoModal }}
        valuesHook={{ values, setValues }}
        criarNovoProcesso={criarNovoProcesso}
      />
      <ProcessoBpoModal
        cepApi={{ getCep, cepResponse }}
        modalHook={{ processoBpoModal, setProcessoBpoModal }}
        valuesHook={{ values, setValues }}
        servicos={servicos}
        salvarProcesso={salvarProcesso}
      />
    </>
  );
}

export default Bpo;
